export const provinciasEspana = [
  "Álava",
  "Albacete",
  "Alicante",
  "Almería",
  "Asturias",
  "Ávila",
  "Badajoz",
  "Baleares",
  "Barcelona",
  "Burgos",
  "Cáceres",
  "Cádiz",
  "Cantabria",
  "Castellón",
  "Ciudad Real",
  "Córdoba",
  "Cuenca",
  "Girona",
  "Granada",
  "Guadalajara",
  "Gipuzkoa",
  "Huelva",
  "Huesca",
  "Jaén",
  "La Rioja",
  "Las Palmas",
  "León",
  "Lleida",
  "Lugo",
  "Madrid",
  "Málaga",
  "Murcia",
  "Navarra",
  "Ourense",
  "Palencia",
  "Pontevedra",
  "Salamanca",
  "Santa Cruz de Tenerife",
  "Segovia",
  "Sevilla",
  "Soria",
  "Tarragona",
  "Teruel",
  "Toledo",
  "Valencia",
  "Valladolid",
  "Bizkaia",
  "Zamora",
  "Zaragoza",
];

export const consultationMethods = {
  online: "Online",
  in_person: "Presencial",
  both: "Online/Presencial",
};

export enum AppointmentType {
  FIRST_VISIT = "Primera visita",
  FOLLOW_UP = "Seguimiento",
  EVALUATION = "Evaluación",
  REVISION = "Revisión",
  DIET_ADJUSTMENT = "Ajuste de dieta",
  PERSONAL = "Personal",
  OTHER = "Otro",
}

export enum AppointmentStatus {
  SCHEDULED = "Programada",
  CONFIRMED = "Confirmada",
  COMPLETED = "Completada",
  CANCELLED = "Cancelada",
  NO_SHOW = "No asistió",
}

export enum PatientStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  SUSPENDED = "suspended",
}

type PatientStatusTranslationsType = {
  [key in PatientStatus]: string;
};

export const PatientStatusTranslations: PatientStatusTranslationsType = {
  [PatientStatus.ACTIVE]: "Activo",
  [PatientStatus.INACTIVE]: "Inactivo",
  [PatientStatus.SUSPENDED]: "Suspendido",
};

export enum ConsultationMode {
  IN_PERSON = "Presencial",
  ONLINE = "Online",
}

export enum ErrorMessages {
  ProvideEmail = "Para registrarse, por favor proporcione su correo electrónico",
  ValidPasswordRequired = "El registro requiere una contraseña válida",
  UserAlreadyRegistered = "Ya existe un usuario registrado con ese correo electrónico",
  OnlyEmailOrPhone = "Solo debe proporcionar un correo electrónico o número de teléfono al registrarse",
  SignupsNotAllowed = "No se permiten registros en esta instancia",
  EmailSignupsDisabled = "Los registros por correo electrónico están deshabilitados",
  EmailLinkInvalidOrExpired = "El enlace de correo electrónico es inválido o ha caducado",
  TokenExpiredOrInvalid = "El token ha caducado o es inválido",
  InvalidNewEmail = "La nueva dirección de correo electrónico proporcionada es inválida",
  PasswordTooShort = "La contraseña debe tener al menos 6 caracteres",
  InvalidCredentials = "Usuario o contraseña incorrectos",
  EmailNotConfirmed = "La cuenta no ha sido confirmada. Por favor, revisa tu correo electrónico para confirmar tu cuenta",
  NewPasswordShouldBeDifferentFromOldPassword = "La nueva contraseña debe ser diferente a la contraseña actual",
}
